import { Spinner } from '@flash-tecnologia/hros-web-ui-v2';
import { FC } from 'react';

type CenteredSpinnerProps = {
  size?: 48 | 16 | 24 | 32 | 64;
};

export const CenteredSpinner: FC<CenteredSpinnerProps> = ({ size = 48 }) => (
  <SpinnerContainer>
    <Spinner size={size} />
  </SpinnerContainer>
);

import styled from 'styled-components';

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
